export default {
  tasks(state) {
    return state.tasks;
  },
  totalTasks(state) {
    return state.totalTasks;
  }
};
